export const contributions = {
	wrapper: {
		display: 'flex',
		flexDirection: 'column',
		minHeight: 'calc(100vh - 280px)',
		height: '100%',
		// overflow: 'auto',
	},
	table: {
		minWidth: 650,
	},

	tableWrap: {
		borderBottom: '1px solid var(--neutral-100)',
	},

	contribution_name: {
		fontWeight: 700,
		color: 'var(--neutral-900)',
	},

	cellText: {
		fontWeight: 700,
		fontSize: '16px',
		lineHeight: 1.75,
		color: 'var(--neutral-900)',
		textAlign: 'right' as const,
	},

	neutral300: {
		color: 'var(--neutral-300)',
	},

	tableCell: {
		padding: '7px 0 ',
	},

	totalRowName: {
		fontWeight: '700',
		fontSize: '20px',
		color: 'var(--neutral-900)',
	},

	totalText: {
		fontWeight: '700',
		fontSize: '20px',
		color: 'var(--neutral-900)',
		textAlign: 'right' as const,
	},

	toPayText: {
		fontSize: '24px',
		fontWeight: '700',
		color: 'var(--primary-700)',
	},

	toPayWrap: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		padding: '20px 18px',
		paddingBottom: '80px',
	},

	headText: {
		textAlign: 'right' as const,
	},

	feeLabel: {
		display: 'flex',
		alignItems: 'center',
		gap: '7px',

		'& .checked': {
			path: {
				fill: 'var(--primary-500)',
			},
		},
	},

	buttonWrap: {
		display: 'flex',
		alignItems: 'center',
		gap: '24px',
		paddingBottom: '24px',
		marginTop: 'auto',
		justifyContent: 'flex-end',

		'@media (max-width: 1199.98px)': {
			display: 'none',
		},
	},

	empty: {
		borderBottom: 'none',
		textAlign: 'center',
		'& .MuiTypography-root': {
			fontSize: '18px !important',
			fontWeight: '700 !important',
		},

		fontSize: '18px !important',
		fontWeight: '700 !important',
	},

	coverFeeTitle: {
		display: 'flex',
		gap: '8px',
		alignItems: 'center',

		'& .MuiCheckbox-root': {
			marginRight: '3px',
		},
	},

	coverFeeTooltip: {
		display: 'flex',

		'& svg': {
			width: '16px',
			height: '16px',
			'& path': {fill: 'var(--neutral-400)'},
		},
	},
};
